import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

//Messages
import MessagesReducer from "./messages/reducer";

//Product
import ProductsReducer from "./products/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Messages: MessagesReducer,
    Products: ProductsReducer,
});

export default rootReducer;